import axios from "axios";

const createAxiosInstance = (baseURL: string, withCredentials = false) => {
  const instance = axios.create({
    baseURL,
    withCredentials,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      return Promise.reject(error);
    },
  );

  return instance;
};

const authApiURL = import.meta.env.VITE_AUTH_API_URI
  ? `${import.meta.env.VITE_AUTH_API_URI}`
  : "http://localhost:3000/api/v1/auth";

const authApi = createAxiosInstance(authApiURL, true);

const apiURL = import.meta.env.VITE_API_URI
  ? `${import.meta.env.VITE_API_URI}`
  : "http://localhost:3000/api/v1";

const api = createAxiosInstance(apiURL, true);

export { api, authApi, apiURL, authApiURL };

api.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const authApiOut = axios.create({
  baseURL: authApiURL,
});

authApiOut.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const verifyEmailApi = axios.create({
  baseURL: apiURL,
});

verifyEmailApi.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const currencyApiURL = import.meta.env.VITE_API_URI
  ? `${import.meta.env.VITE_API_URI}/currency`
  : "http://localhost:3000/api/v1/currency";

export const currencyApi = axios.create({
  baseURL: currencyApiURL,
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

currencyApi.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const depositApiURL = import.meta.env.VITE_API_URI
  ? `${import.meta.env.VITE_API_URI}/deposit`
  : "http://localhost:3000/api/v1/deposit";

export const depositApi = axios.create({
  baseURL: depositApiURL,
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

depositApi.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const backendApiURL = import.meta.env.VITE_API_URI
  ? `${import.meta.env.VITE_API_URI}`
  : "http://localhost:3000/api/v1";

export const ggrApiURL = import.meta.env.VITE_GGR_API_URI
  ? `${import.meta.env.VITE_GGR_API_URI}`
  : "http://localhost:3001/api/v1";

export const backendApi = axios.create({
  baseURL: backendApiURL,
});

export const ggrApi = axios.create({
  baseURL: ggrApiURL,
});

export const bonusApiURL = import.meta.env.VITE_BONUS_API_URI
  ? `${import.meta.env.VITE_BONUS_API_URI}`
  : "http://localhost:7000/api/v1";

export const bonusApi = axios.create({
  baseURL: bonusApiURL,
});

bonusApi.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const kycApiURL = import.meta.env.VITE_API_URI
  ? `${import.meta.env.VITE_API_URI}/kyc`
  : "http://localhost:3000/api/v1/kyc";

export const kycApi = axios.create({
  baseURL: kycApiURL,
});

export const getJwtTokenFromCookie = () => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("jwtToken="))
    ?.split("=")[1];
};

backendApi.interceptors.request.use(
  (config) => {
    const jwtToken = getJwtTokenFromCookie();
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const socketURL = import.meta.env.VITE_API
  ? `${import.meta.env.VITE_SOCKET_API}/api/v1/socket`
  : "http://localhost:3000/api/v1/socket";
